import { useEffect } from 'react'
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs'
import images from 'react-payment-inputs/images'

export default function CreditCardInput({
  handleCardNumberChange,
  handleExpiryDateChange,
  handleCVCchange,
  handleCardTypeChange,
  handleErred
}) {
  const {
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
    meta
  } = usePaymentInputs()

  useEffect(() => {
    if (meta.cardType && meta.cardType.type) {
      handleCardTypeChange(meta.cardType.type)
    }
  }, [handleCardTypeChange, meta.cardType])

  useEffect(() => {
    if (handleErred) {
      handleErred(meta.error)
    }
  }, [handleErred, meta.error])

  return (
    <PaymentInputsWrapper
      {...wrapperProps}
      styles={{
        inputWrapper: {
          base: {
            padding: '0 0 0 12px',
            border: '1px solid rgba(0, 0, 60, 0.2)'
          }
        },
        input: {
          base: {
            boxShadow: 'none',
            fontSize: 14,
            marginTop: '-1px'
          },
          cardNumber: {
            width: '14em'
          },
          cvc: {
            marginLeft: 'auto'
          }
        },
        fieldWrapper: {
          base: {
            width: '100%'
          }
        }
      }}
    >
      <svg {...getCardImageProps({ images })} />
      <input {...getCardNumberProps({ onChange: handleCardNumberChange })} />
      <input {...getExpiryDateProps({ onChange: handleExpiryDateChange })} />
      <input {...getCVCProps({ onChange: handleCVCchange })} />
    </PaymentInputsWrapper>
  )
}
